import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-languages-links',
    templateUrl: './languages-links.component.html',
})
export class LanguagesLinksComponent {
    constructor(private translate: TranslateService) {}

    setLanguage(language: string): void {
        this.translate.use(language);
    }
}
